import { getReasonPhrase } from "http-status-codes";

export class ApiClientError<TError = unknown> extends Error {
  public data: TError;
  public reason: string;
  public status: number;

  constructor(status: number, data: TError, message?: string) {
    super(message);
    this.status = status;
    this.data = data;
    this.reason = getReasonPhrase(status);
  }
}

export function hasApiClientFieldErrors(
  error: unknown,
): error is ApiClientError<{ fieldErrors: Record<string, string[]> }> {
  return (
    isApiClientError(error) &&
    typeof error.data === "object" &&
    error.data !== null &&
    "fieldErrors" in error.data &&
    typeof error.data.fieldErrors === "object" &&
    error.data.fieldErrors !== null
  );
}

export function isApiClientError(error: unknown): error is ApiClientError {
  return error instanceof ApiClientError;
}
